




































































































































































import { Component, Ref, Watch } from 'vue-property-decorator';
import Vue from 'vue';
import { getModule } from 'vuex-module-decorators';
import Viewpoints from '@/store/modules/Viewpoints';
import Choices from '@/store/modules/Choices';
import Decisions from '@/store/modules/Decisions';
import { VIEWPOINT_API } from '@/api/ViewpointApi';
import { REQUIRED } from '@/rules';
import ShareDialogStyleOptions from '@/components/share/ShareDialogStyleOptions.vue';
import ShareDialogTypeOptions from '@/components/share/ShareDialogTypeOptions.vue';
import _ from 'lodash';
import DescriptionEditor from '@/components/common/DescriptionEditor.vue';
import CardTitle from '@/components/common/CardTitle.vue';

const viewpointsModule = getModule(Viewpoints);
const choicesModule = getModule(Choices);
const decisionsModule = getModule(Decisions);

@Component({
    components: { DescriptionEditor, ShareDialogStyleOptions, ShareDialogTypeOptions, CardTitle },
})
export default class ChoiceInputShareDialog extends Vue {
    private styles: any = { id: '1', name: 'Default Theme' };
    private viewType: 'FORM' | 'QUESTIONNAIRE' = 'FORM';

    private REQUIRED = REQUIRED;

    private show = false;

    private selectedViewpointIds: string[] = [];
    private selectedChoiceId: string | null = null;
    private name: string = this.selectedDecision ? this.selectedDecision.name : '';
    private description: string = '';

    private generatedLink: string | null = null;
    private copiedTooltip = false;
    private generating = false;

    @Ref()
    private linkField: HTMLInputElement;

    get choicesList() {
        return choicesModule.choicesList;
    }

    get viewpointsList() {
        return _.sortBy(viewpointsModule.decisionViewpoints || [], 'name');
    }

    get selectedDecision() {
        return decisionsModule.selectedDecision;
    }

    get selectedDecisionId() {
        return decisionsModule.selectedDecisionId;
    }

     get singularChoiceLabel() {
        return decisionsModule.singularChoiceLabel;
    }

    get pluralChoiceLabel() {
        return decisionsModule.pluralChoiceLabel;
    }

    @Watch('show')
    onShowChange() {
        this.selectedViewpointIds = [];
        this.generatedLink = null;
    }

    private async createShareLink() {
        if (!this.name) return;
        let decisionId = this.selectedDecisionId;
        if (!decisionId) return;

        this.generating = true;
        let viewpointIds = this.selectedViewpointIds;
        let choiceId = this.selectedChoiceId;

        // let cookieKey = `chis-${decisionId}-${viewpointIds.join(".")}-${choiceId}`
        // if (this.$cookies.isKey(cookieKey)) {
        //     this.generatedLink = this.$cookies.get(cookieKey)
        // } else {
        let shareLinkData = await VIEWPOINT_API.generateChoiceInputForm(
            decisionId,
            this.name,
            this.description,
            viewpointIds,
            choiceId || undefined,
            this.viewType,
            this.styles
        );
        this.generatedLink = `http${window.location.hostname === 'localhost' ? '' : 's'}://${
            window.location.host
        }/input/choice?form=${shareLinkData.formId}`;
        //     this.$cookies.set(cookieKey, this.generatedLink)
        // }
        this.generating = false;
    }

    private copy() {
        this.copiedTooltip = true;
        setTimeout(() => (this.copiedTooltip = false), 2500);
    }

    private viewpointListChange() {
        while (this.selectedViewpointIds.length > 5) {
            this.selectedViewpointIds.pop();
        }
    }
}
